import React from "react";

export default function Footer() {
  return (
    <footer className="rounded-t-[32px] text-center bg-secondary py-8 text-main font-normal text-sm w-full max-w-7xl">
      © {new Date().getFullYear()} quentinrobert.com All rights reserved
    </footer>
  );
}
